import Vue from 'vue';
import './presentation/assets/css/global.scss';
import { startup } from '@eureka/startup';
import { i18n } from './infrastructure/locales';
import Overview from './presentation/Overview.vue';
startup({
    projectName: 'eureka',
    preset: {
        name: 'eureka',
    },
    pageInit() {
        return Promise.resolve();
    },
});
new Vue({
    i18n,
    render: h => h(Overview),
}).$mount('#app');
